"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Trash = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 14,
  height: 16,
  viewBox: "0 0 14 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.111 3.2h3.111A.79.79 0 0114 4a.79.79 0 01-.778.8h-.778v8.8c0 1.325-1.044 2.4-2.333 2.4H3.89c-1.289 0-2.333-1.075-2.333-2.4V4.8H.778A.79.79 0 010 4c0-.442.348-.8.778-.8h3.11v-.8c0-1.325 1.046-2.4 2.334-2.4h1.556c1.288 0 2.333 1.075 2.333 2.4v.8zM5.25 7a.75.75 0 00-.75.75v4.5a.75.75 0 001.5 0v-4.5A.75.75 0 005.25 7zM8 7.75a.75.75 0 011.5 0v4.5a.75.75 0 01-1.5 0v-4.5zM6.223 1.6a.79.79 0 00-.778.8v.8h3.111v-.8a.79.79 0 00-.777-.8H6.223z",
  fill: "#ACB3BE"
}));
var _default = exports.default = Trash;